import React from 'react'
import Layouts301 from './Layouts301';
import Layouts400 from './Layouts400';
import Layouts401 from './Layouts401';
import Layouts403 from './Layouts403';
import Layouts404 from './Layouts404';
import Layouts500 from './Layouts500';

export default function LayoutsErrors() {
  return (
    <section><a className="anchor" id="errors"></a>
      <div className="push--bottom grid">
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-12">
            <h1>Error Pages</h1>
            <p>Live examples of the error pages can be seen below:</p>
            <Layouts301/>
            <Layouts400/>
            <Layouts401/>
            <Layouts403/>
            <Layouts404/>
            <Layouts500/>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/LayoutsErrors.js